
import { Options } from "vue-class-component";
import {
  SubmitBar,
  Field,
  Divider,
  RadioGroup,
  Radio,
  Cell,
  DatetimePicker,
  Popup,
  Toast,
} from "vant";
import BasePage from "@/common/BasePage";
import ServeItem from "@/components/item/ServeItem.vue";
import TenantVo from "@/vo/TenantVo";

import WxUtil from "@/util/WxUtil";
import AppUtil from "@/util/AppUtil";
@Options({
  components: {
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Cell.name]: Cell,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [SubmitBar.name]: SubmitBar,
    [Field.name]: Field,
    [Divider.name]: Divider,
    "serve-item": ServeItem,
  },
})
export default class AddOrder extends BasePage {
  border = false;
  /**支付选项等 */
  config = {
    /**是否显示日期选择 */
    showDate: false,
    /**是否显示时间选择 */
    showTime: false,
    payIdx: 0,
    payArr: [
      { title: "微信支付", url: "/zhPay/wxpay/wxJSAPIPay" },
      { title: "会员卡支付", url: "/zhPay/beautyCardPay/gotoPay" },
      { title: "股本支付", url: "/zhPay/shareholderCapitalPay/gotoPay" },
    ],
    /**用于提交订单 */
    orderData: {
      /**到店日期 */
      arrivalDate: "",
      /**服务时间 */
      arrivalTime: "",
      orderName: "",
      orderPhone: "",
      orderType: 1,
      serveJson: "",
    },
    // arrivalDate:"",
    /**当前日期 */
    curDate: new Date(),
    /**七天后的日期 */
    date7: new Date(new Date().getTime() + 86400000 * 7),
  };
  arrivalDate=""
  tenantInfo: TenantVo = TenantVo.getInstance();
  mounted() {
    if (!this.serveArr.length) {
      this.$toast("缺少服务信息");
      setTimeout(() => {
        this.$router.replace({
          path: "/ServeList",
        });
      }, 2000);
    }

    // console.log("get_wx",this.get_wx())
  }
  public get maxDate(){
    return new Date()
  }
  /**选中的服务列表 */
  public get serveArr() {
    return this.appVo.serveArr || [];
  }
  public get price() {
    let num = 0;
    this.appVo.serveArr.map((val: any) => {
      if(this.config.payIdx==2){
        num += val.normalPrice * val.serveNum;
      }else{
num += val.price * val.serveNum;
      }
      
    });
    return num;
  }
  /**用于日期选择组件 */
  date_formatter(type: string, val: number) {
    if (type === "month") {
      return `${val}月`;
    }
    if (type === "day") {
      return `${val}日`;
    }
    return val;
  }
   submit_date(date: Date) {
    console.log("选中的submit_date",date);

    this.config.showDate = false;
    let hour=date.getHours();
    if(hour<this.tenantInfo.startHour){
      Toast("您选择的时间早于开店时间，已自动为您调整");
      hour=this.tenantInfo.startHour;
    }else if(hour>this.tenantInfo.endHour){
      Toast("您选择的时间晚于关店时间，已自动为您调整");
      hour=this.tenantInfo.endHour-1;
    }
     this.config.orderData.arrivalTime = hour+":"+date.getMinutes();
     this.config.orderData.arrivalDate=date.getFullYear() + "/" + (date.getMonth()*1+1) + "/" + date.getDate();
     
      this.arrivalDate=this.config.orderData.arrivalDate+" "+this.config.orderData.arrivalTime;
  }
  private submit_time(time: string) {
    // console.log("选中的事件",val);
    this.config.showTime = false;
    this.config.orderData.arrivalTime = time;
  }
  /**提交订单 */
   submit_click() {
    if(!AppUtil.check_phone( this.config.orderData.orderPhone)){
      return Toast("请输入正确的中国区手机号")
    }
    // [{"id":1,"serveNum":2},{"id":2,"serveNum":2}]
    let arr: any[] = [];
    this.serveArr.map((val: any) => {
      arr.push({ id: val.id, serveNum: val.serveNum });
    });
    this.config.orderData.serveJson = JSON.stringify(arr);
    AppUtil.request(
      {
        url: "/zhOrder/serveOrder/createServeOrder",
        method: "post",
        data: this.config.orderData,
      },
      (res: any) => {
        // console.log("首页门店信息",res);
        // this.tenantInfo.setData(res.data);
        this.req_pay(res.data.id);
      },
      "加密提交中..."
    );
  }
  // pay_change(index:number){
  //   this.config.payIdx=index;
  //   console.log("pay_change",index);
  //   console.log(this.serveArr);
    
  // }
  /**请求完成支付 */
  private req_pay(orderId: number) {
    // console.log("支付订单id：", orderId);
    /**0为微信支付 */
    let payIdx = this.config.payIdx;
    let that = this;
    AppUtil.request(
      {
        url: this.config.payArr[payIdx].url,
        method: "post",
        data: {
          orderId,
          payType: 1,
        },
      },
      (res: any) => {
        //
        if (payIdx) {
          this.$toast("支付成功,即将跳转订单页面");
        } else {
          // console.log("微信支付参数1", res);
         
          WxUtil.get_wx().then((wxsdk) => {
          
            wxsdk.chooseWXPay({
              timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
              package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: res.data.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
              paySign: res.data.paySign, // 支付签名
              success: function () {
                // 支付成功后的回调函数
                that.$router.push({
                  path: "/serve/orders",
                });
              },
            });
          });
        }
        // this.tenantInfo.setData(res.data);
        // this.req_pay(res.data.id);
      },
      "等待支付订单...",
      () => {
        if (payIdx) {
          //非微信支付，直接跳转订单页面
          setTimeout(() => {
            this.$router.push({
              path: "/serve/orders",
            });
          }, 2000);
        }
      }
    );
  }
}
